export default "__VITE_ASSET__yJGvJxgd__"